/**
 * Etiqueta legible de pasajeros a partir del título de categoría de Bókun
 * ("Adults", "Children", "Infant"…): "1 adulto", "2 adultos", "1 adult".
 * Si la categoría no se reconoce se conserva el título original.
 */
type Lang = "es" | "en" | "fr" | "de" | "it" | "pt";
const FORMS: Record<string, Record<Lang, [string, string]>> = {
  adult: { es: ["adulto", "adultos"], en: ["adult", "adults"], fr: ["adulte", "adultes"], de: ["Erwachsener", "Erwachsene"], it: ["adulto", "adulti"], pt: ["adulto", "adultos"] },
  child: { es: ["niño", "niños"], en: ["child", "children"], fr: ["enfant", "enfants"], de: ["Kind", "Kinder"], it: ["bambino", "bambini"], pt: ["criança", "crianças"] },
  infant: { es: ["infante", "infantes"], en: ["infant", "infants"], fr: ["bébé", "bébés"], de: ["Kleinkind", "Kleinkinder"], it: ["neonato", "neonati"], pt: ["bebê", "bebês"] },
  senior: { es: ["adulto mayor", "adultos mayores"], en: ["senior", "seniors"], fr: ["senior", "seniors"], de: ["Senior", "Senioren"], it: ["senior", "senior"], pt: ["idoso", "idosos"] },
  student: { es: ["estudiante", "estudiantes"], en: ["student", "students"], fr: ["étudiant", "étudiants"], de: ["Student", "Studenten"], it: ["studente", "studenti"], pt: ["estudante", "estudantes"] },
};
const PATTERNS: Array<[string, RegExp]> = [
  ["infant", /infant|baby|beb[eéê]|neonat|kleinkind/i],
  ["child", /child|kid|niñ|nin[oa]s?\b|enfant|kind|bambin|crian/i],
  ["senior", /senior|mayor|elder|idos/i],
  ["student", /student|estudiant|étudiant|studen/i],
  ["adult", /adult|erwachs/i],
];

export function categoryKind(title: string): string | null {
  return PATTERNS.find(([, re]) => re.test(title))?.[0] ?? null;
}

export function participantLabel(quantity: number, title: string, language: string): string {
  const lang = (["es", "en", "fr", "de", "it", "pt"].includes(language.slice(0, 2)) ? language.slice(0, 2) : "es") as Lang;
  const kind = categoryKind(title);
  if (!kind) return `${quantity} ${title}`;
  const [one, many] = FORMS[kind][lang];
  return `${quantity} ${quantity === 1 ? one : many}`;
}

/** "00:00" o vacío de Bókun significa que el tour no tiene horario fijo. */
export function isFlexibleStartTime(t: string | null | undefined): boolean {
  const v = (t ?? "").trim();
  return !v || /^0?0:00(:00)?$/.test(v);
}
